import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PendingRedirect = {
  // Always a validated external http(s) href — internal app paths navigate
  // immediately from the redirectToUrl client tool and never reach the toast.
  url: string;
  // Changes on every agent request, even for an identical URL, so the
  // toast countdown restarts when the agent re-offers the same page.
  requestId: number;
};

export type ConversationalAgentState = {
  pendingRedirect: PendingRedirect | null;
};

const initialState: ConversationalAgentState = {
  pendingRedirect: null,
};

const conversationalAgentSlice = createSlice({
  name: 'conversationalAgent',
  initialState,
  reducers: {
    setPendingRedirect(state, action: PayloadAction<PendingRedirect>) {
      state.pendingRedirect = action.payload;
    },
    clearPendingRedirect(state) {
      state.pendingRedirect = null;
    },
  },
});

export const { setPendingRedirect, clearPendingRedirect } =
  conversationalAgentSlice.actions;

export default conversationalAgentSlice.reducer;
